<template>
	<div id="layout-default">
		<header>
			<TopBar></TopBar>
		</header>
		<content>
			<slot/>
		</content>
		<footer>
			<BottomBar></BottomBar>
		</footer>
	</div>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
	import TopBar from '../../components/TopBar';
	import BottomBar from '../../components/BottomBar';
	import KeyListenerView from '../../components/KeyListenerView';

	@Component({
		components: {
			TopBar,
			BottomBar,
		},
	})
	export default class LayoutDefault extends KeyListenerView {

		mounted() {
			this.addKeyboardListener('ALT-T', this.toggleFullScreen, 'Fullscreen');

			super.mounted();
		}

		destroyed() {
			super.destroyed();
		}

		toggleFullScreen() {
			var doc = window.document;
			var docEl = doc.documentElement;

			var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
			var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

			if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
				requestFullScreen.call(docEl);
			}
			else {
				cancelFullScreen.call(doc);
			}
		}

	}


</script>

<style lang="scss">
	#layout-default {
		background: #0001A4;
		height: 100vh;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		justify-content: flex-start;
		align-content: stretch;
		align-items: flex-start;
	}

	#layout-default > * {
		flex: 0 1 auto;
		width: 100vw;
	}

	#layout-default > content {
		flex: 1 1 auto;
		overflow: hidden;
		flex-basis: 0;
	}
</style>